import React, {useState} from 'react';
import * as PropTypes from 'prop-types';
import {Stepper} from './Stepper';

export const YearStepper = ({startYear, onYearChanged, minYear, maxYear, userpilot, cy}) => {
	const [year, setYear] = useState(startYear);

	const changeYear = newYear => {
		setYear(newYear);
		if (onYearChanged) {
			onYearChanged(newYear);
		}
	};

	const prevYear = () => changeYear(year - 1);
	const nextYear = () => changeYear(year + 1);

	const canNavigateBack = minYear !== undefined && minYear !== null ? year > minYear : true;
	const canNavigateForward = maxYear !== undefined && maxYear !== null ? year < maxYear : true;

	return (
		<Stepper
			width={63}
			onForward={nextYear}
			onBack={prevYear}
			canNavigateBack={canNavigateBack}
			canNavigateForward={canNavigateForward}
			userpilot={userpilot}
			cy={cy}
		>
			{year}
		</Stepper>
	);
};

YearStepper.propTypes = {
	/**
	 * Set what year to show initially. Defaults to current year
	 */
	startYear: PropTypes.number,
	onYearChanged: PropTypes.func,
	minYear: PropTypes.number,
	maxYear: PropTypes.number,
	/**
	 * ID needed for on-boarding tool
	 */
	userpilot: PropTypes.string,
	/**
	 * ID needed for Cypress testing
	 */
	cy: PropTypes.string,
};

YearStepper.defaultTypes = {
	startYear: new Date().getFullYear(),
};
